export default function validateCreditCardNumber(value: string) {
  // Accept only digits, dashes or spaces
  if (value.length < 19 || /[^0-9-\s]+/.test(value))
    return 'Credit card number is not valid';

  // The Luhn Algorithm. It's so pretty.
  let nCheck = 0,
    bEven = false;
  value = value.replace(/\D/g, '');

  for (let n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n);
    let nDigit = parseInt(cDigit, 10);

    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 === 0 || 'Credit card number is not valid';
}
